import { forAllCallback } from "kwp-core/scripts/utils/helpers";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
    const init = () => {
        forAllCallback(".content-block.content-block--showcase", (el) => {
            const tween = gsap.from(el, {
                opacity: 0,
                duration: 0.5,
            });

            ScrollTrigger.create({
                trigger: el,
                start: "top bottom",
                end: "bottom top",
                animation: tween,
                once: false,
                once: true,
            });
        });
    };

    init();
};
